import Tooltip, {TooltipProps} from '@mui/material/Tooltip';

import {styled} from '@mui/material/styles';

export const CTooltip = styled(Tooltip)<TooltipProps>(
  (/* { theme } */) => ({
  }),
);
